<app-header></app-header>
<div id="content">
    <app-searchbar></app-searchbar>
    <app-exclusiveDeals></app-exclusiveDeals>
</div>
<app-homeFooter></app-homeFooter>